// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1ddfcdc9-567":"ff27af0240c79608f325","1ddfcdc9-452":"8674092e2e529b4d7970","1ddfcdc9-812":"619fafd160774c0b81f8","1ddfcdc9-83":"99a037aea7d7a921e8c1"}[chunkId] + ".js";
};